export default __webpack_public_path__ + "static/SofiaProSemiBold-2f30aa779ad61c8e0ac3eb0317eaec61.woff";